export default function AILearning() {
  return (
    <div className="py-4">
      <div className="max-w-7xl mx-auto px-12 sm:px-4">
        {/* Header Section */}
        <header className="text-center">
          <h1 className="text-balance text-5xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]">
            AI‑Based Learning – Inspire 365
          </h1>
          <p className="mx-auto max-w-3xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium">
            Inspire 365 delivers daily AI‑generated video podcasts for children, featuring stories of Indian
            superheroes—scientists, leaders, and innovators. Each episode inspires a positive mindset every morning,
            motivating children to learn better, make good choices, and stay away from negative influences.
          </p>
        </header>

        {/* Main Content Section */}
        <div className="mt-20 md:mt-12 sm:mt-8 grid grid-cols-2 md:grid-cols-1 gap-8 md:gap-6 sm:gap-4 items-start mb-12 md:mb-8 sm:mb-6">
          {/* Left Side - Image */}
          <div className="w-full h-full">
            <img
              src="/images/new-landing-page/aiLearningImage.svg"
              alt="Inspire 365 Dashboard showing Today's Lessons and Students"
              className="w-full h-auto rounded-3xl sm:rounded-2xl shadow-lg"
            />
          </div>

          {/* Right Side - Benefits */}
          <aside aria-label="Key benefits" className="self-center space-y-6 md:space-y-5 sm:space-y-4">
            <section>
              <h3 className="text-lg md:text-base font-semibold">Key Benefits for Children:</h3>
              <ul className="mt-2 list-disc space-y-1 pl-5 text-sm sm:text-xs text-muted-foreground">
                <li>Daily Inspiration & Positive Mindset: Start each day motivated and optimistic.</li>
                <li>Interactive Learning: Engaging video podcasts capture attention and encourage reflection.</li>
                <li>Continuous Growth: Learn values, history, and innovation lessons every day.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg md:text-base font-semibold">Key Benefits for Parents:</h3>
              <ul className="mt-2 list-disc space-y-1 pl-5 text-sm sm:text-xs text-muted-foreground">
                <li>Stay Connected: Track what children are learning daily.</li>
                <li>Encourages Discussion: Sparks meaningful conversations at home.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg md:text-base font-semibold">Key Benefits for Schools:</h3>
              <ul className="mt-2 list-disc space-y-1 pl-5 text-sm sm:text-xs text-muted-foreground">
                <li>Marketing & Admissions Magnet: Branded daily content attracts prospective parents.</li>
                <li>Boosts Parent Retention: Engaged parents are more satisfied and loyal.</li>
                <li>Demonstrates Innovation: Shows the school as forward‑thinking and tech‑savvy.</li>
              </ul>
            </section>
          </aside>
        </div>

        {/* Bottom Text */}
        <div className="text-center">
          <p className="text-sm sm:text-xs text-gray-700 max-w-6xl mx-auto leading-relaxed px-4">
            Inspire 365 turns everyday learning into a daily, inspiring journey, fostering positivity, empowering children, delighting parents, and boosting school visibility.
          </p>
        </div>
      </div>
    </div>
  );
}